// extracted by mini-css-extract-plugin
export default {"body":"youtube_body__QD6Sc","cont":"youtube_cont__cwOvp","frame":"youtube_frame__iasED"};